import { render, staticRenderFns } from "./collection-link-minimal.vue?vue&type=template&id=f51e2110&"
import script from "./collection-link-minimal.vue?vue&type=script&lang=js&"
export * from "./collection-link-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports